import React from 'react';
import { Animated } from "react-animated-css";
import Config from '../../config';

const { backendUrl } = Config.network;


class FilterButton extends React.Component {

  render() {
    const {
      Icon,
      text,
      className,
      customStyle,
      name,
      handleClick,
      delayIn,
      isVisible,
      value,
      isDisabled,
      isOption,
      isSelected,
      iconUrl,
    } = this.props;
    return (
      <Animated
        isVisible={isVisible}
        className={`rounded-button ${className}`}
        animationOutDelay={450}
        animationInDelay={delayIn}
        style={customStyle}
        animateOnMount={false}
      >
        {!isOption && isSelected ? <span className="connector-point"></span> : null}
        {!isOption && isSelected ? <span className="connector-point"></span> : null}
        {isOption ? <span className="connector"></span> : null}
        <div
          id={value}
          name={name}
          value={text}
          onClick={isDisabled ? null : handleClick}
          className="w-100 h-100 circle-base"
          style={iconUrl ? {backgroundImage: `url(${backendUrl}${iconUrl})`} : null}
        >
          <div
              className="inner-content"
          >
            { Icon ? <Icon /> : null }
            { text }
          </div>
        </div>
      </Animated>
    );
  }
}

export default FilterButton;
